export default __webpack_public_path__ + "static/media/tampon_arsenio.d0e49ddb.jpeg";